"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splitPath_1 = __importDefault(require("./splitPath"));
var clone_1 = __importDefault(require("../fn/clone"));
exports.default = (function (obj, path) {
    var parts = (0, splitPath_1.default)(path);
    var val = obj;
    var isRoot = parts.length === 1 && parts[0] === "";
    if (!isRoot) {
        for (var i = 0; i < parts.length; i += 1) {
            if (val && val[parts[i]] !== undefined) {
                val = val[parts[i]];
            }
            else {
                val = undefined;
                break;
            }
        }
    }
    if (val &&
        val.toString &&
        (val.toString() === "[object Object]" || val instanceof Array)) {
        val = (0, clone_1.default)(val);
    }
    return val;
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0VmFsdWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm4vZ2V0VmFsdWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSwwREFBb0M7QUFDcEMsc0RBQWdDO0FBQ2hDLG1CQUFlLFVBQUMsR0FBRyxFQUFFLElBQUk7SUFDdkIsSUFBSSxLQUFLLEdBQUcsSUFBQSxtQkFBUyxFQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVCLElBQUksR0FBRyxHQUFHLEdBQUcsQ0FBQztJQUNkLElBQUksTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxFQUFFLENBQUM7SUFFbkQsSUFBSSxDQUFDLE1BQU0sRUFBRTtRQUNYLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDeEMsSUFBSSxHQUFHLElBQUksR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLFNBQVMsRUFBRTtnQkFDdEMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQzthQUNyQjtpQkFBTTtnQkFDTCxHQUFHLEdBQUcsU0FBUyxDQUFDO2dCQUNoQixNQUFNO2FBQ1A7U0FDRjtLQUNGO0lBRUQsSUFDRSxHQUFHO1FBQ0gsR0FBRyxDQUFDLFFBQVE7UUFDWixDQUFDLEdBQUcsQ0FBQyxRQUFRLEVBQUUsS0FBSyxpQkFBaUIsSUFBSSxHQUFHLFlBQVksS0FBSyxDQUFDLEVBQzlEO1FBQ0EsR0FBRyxHQUFHLElBQUEsZUFBSyxFQUFDLEdBQUcsQ0FBQyxDQUFDO0tBQ2xCO0lBRUQsT0FBTyxHQUFHLENBQUM7QUFDYixDQUFDLEVBQUMifQ==